module.exports = __webpack_public_path__ + "static/noble-mtg_clb-1b9968be78952af957e41eb63148fb6b.jpg";